import { render, staticRenderFns } from "./sourcing-select.vue?vue&type=template&id=535e593f&scoped=true"
import script from "./sourcing-select.vue?vue&type=script&lang=js"
export * from "./sourcing-select.vue?vue&type=script&lang=js"
import style0 from "./sourcing-select.vue?vue&type=style&index=0&id=535e593f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535e593f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535e593f')) {
      api.createRecord('535e593f', component.options)
    } else {
      api.reload('535e593f', component.options)
    }
    module.hot.accept("./sourcing-select.vue?vue&type=template&id=535e593f&scoped=true", function () {
      api.rerender('535e593f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quotation-apply/sourcing-select.vue"
export default component.exports